const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3080';
const BACKEND_WARMUP_COOLDOWN_MS = 5 * 60 * 1000;

const buildUrl = (path) => `${API_BASE_URL}${path}`;
let backendWarmupPromise = null;
let backendWarmupCompletedAt = 0;

// Start Cloud Run and Earth Engine initialization before the user submits a
// field. This is deliberately best-effort: warm-up failures never block UI.
export function warmBackend() {
  if (backendWarmupPromise) return backendWarmupPromise;
  if (Date.now() - backendWarmupCompletedAt < BACKEND_WARMUP_COOLDOWN_MS) {
    return Promise.resolve();
  }

  backendWarmupPromise = fetch(buildUrl('/health'), { cache: 'no-store' })
    .then(response => {
      if (response.ok) backendWarmupCompletedAt = Date.now();
    })
    .catch(() => undefined)
    .then(() => {
      backendWarmupPromise = null;
    });

  return backendWarmupPromise;
}

// Fetch an ET result and, on an HTTP error, annotate the body with `httpStatus`
// so callers can tell a transient server error (5xx / 4xx) apart from a genuine
// no-data response (200 with an empty array). Backward-compatible: a success
// still returns the array unchanged, and an error body still carries `.error`.
async function fetchEtResult(url) {
  const response = await fetch(url);
  let data = null;
  try { data = await response.json(); } catch (e) { data = null; }
  if (!response.ok) {
    const body = (data && typeof data === 'object' && !Array.isArray(data)) ? data : {};
    body.httpStatus = response.status;
    if (!body.error) body.error = 'server_error';
    return body;
  }
  return data;
}

export async function getPointMarkerValue(lat, lng) {
  return fetchEtResult(buildUrl(`/api/users?lat=${lat}&lng=${lng}`));
}

export async function getPolygonValue(polygon) {
  return fetchEtResult(buildUrl(`/api/users?type=${polygon.type}&coordinates=${polygon.coordinates}`));
}

export async function createUser(data) {
    const response = await fetch(buildUrl(`/api/user`), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({user: data})
      })
    return await response.json();
}

export async function getGee() {
    const response = await fetch(buildUrl(`/mapid`));
    return await response;
}
